import { PlayerRole } from '@deadpan/shared';
import { Translations } from '@deadpan/shared';

export const getRoleConfig = (t: Translations) => ({
  [PlayerRole.DEADPAN]: { name: t.roles.deadpan, emoji: '🎭', gradient: 'from-purple-500 to-pink-500' },
  [PlayerRole.FACT_SPEAKER]: { name: t.roles.fact_speaker, emoji: '📢', gradient: 'from-green-500 to-emerald-500' },
  [PlayerRole.DETECTIVE]: { name: t.roles.detective, emoji: '🔍', gradient: 'from-blue-500 to-indigo-500' },
  [PlayerRole.WORDSMITH]: { name: t.roles.wordsmith, emoji: '✍️', gradient: 'from-orange-500 to-amber-500' },
  [PlayerRole.UNDERCOVER]: { name: (t.roles as any).undercover || 'Undercover', emoji: '🕵️', gradient: 'from-red-500 to-rose-500' },
  [PlayerRole.CIVILIAN]: { name: (t.roles as any).civilian || 'Civilian', emoji: '🧑‍💼', gradient: 'from-yellow-500 to-orange-500' },
  [PlayerRole.BLANK]: { name: (t.roles as any).blank || 'Blank', emoji: '⬜', gradient: 'from-sky-500 to-blue-500' },
});

